import styled from 'styled-components';
import { colors } from "../../../utils/colors";

export const ProductWrapper = styled.div`
    max-width: 1165px;
    margin: 100px auto 0;
    width: 100%;
    padding: 20px;
    background: ${colors.WHITE};
    border-radius: 5px;
    transition: 200ms cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    align-items: center;
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);

    @media (max-width: 1200px) {
        flex-direction: column;
        width: calc(100% - 35px);
        gap: 20px;
    }

    @media (max-width: 400px) {
        padding: 10px;
    }
`;

export const ProductLeft = styled.div`
    position: relative;
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;

    @media (max-width: 1200px) {
        width: 100%;
    }
`;

export const ProductImage = styled.img`
    max-width: 400px;
    width: 90%;
    margin: 0 auto;
`;

export const DotWrapper = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
`;

export const Dots = styled.span`
    background: ${(prop) => prop.isActive === true ? colors.CREAM : colors.WHITE};
    height: 20px;
    width: 20px;
    border: 2px solid ${colors.CREAM};
    border-radius: 50%;
    cursor: pointer;
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
`;

export const ProductRight = styled.div`
    @import url('https://fonts.googleapis.com/css2?family=Ubuntu&display=swap');
    font-family: 'Ubuntu', sans-serif;
    width: 50%;
    background: ${colors.GRAY_LIGHT};
    border-radius: 5px;
    height: 100%;
    padding: 20px;
    color: ${colors.BLUE};

    @media (max-width: 1200px) {
        width: 100%;
    }

    @media (max-width: 400px) {
        padding: 10px;
    }
`;

export const ProductTitle = styled.h1`
    margin-bottom: 20px;
`;

export const ProductText = styled.div`
    margin-bottom: 10px;
    line-height: 1.5;
    text-align: justify;
`;

export const BottomBox = styled.div`
    background-color: ${colors.CREAM};
    border-radius: 5px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;

    @media (max-width: 550px) {
       flex-direction: column;
       gap: 15px;
    }
`;

export const FieldWrapper = styled.div`
    padding: 5px;
    width: 120px;
    background: ${colors.WHITE};
    display: flex;
    justify-content: center;
    align-items: center;
    height: 65px;
    position: relative;
    border-radius: 5px;
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);

    @media (max-width: 550px) {
        width: 100%;
    }
`;

export const ProductInput = styled.h4`  
`;

export const CreamText = styled.span` 
    color: ${(prop) => prop.count < 10 ? colors.BLACK : colors.CREAM};
    font-weight: bold;
    background-color: ${(prop) => prop.count < 10 ? colors.YELLOW : 'transparent'};
    padding: ${(prop) => prop.count < 10 ? '5px 10px' : 0};
    border-radius: ${(prop) => prop.count < 10 ? '3px' : 0};
`;

export const ButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    position: absolute;
    right 10px;
    top: 5px;
`;

export const QuantityButton = styled.button`
    background: ${(prop) => prop.disabled === true ? colors.LIGHT_CREAM : colors.CREAM};
    color: ${colors.WHITE};
    border: none;
    padding: 5px 10px;
    border-radius: 5px;
    cursor: ${(prop) => prop.disabled === true ? 'not-allowed' : 'pointer'};
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
`;

export const RecommendedProducts = styled.h2`
    color: ${colors.WHITE};
    text-align: center;
    padding: 0 20px;
    margin-top: 50px;
    text-transform: uppercase;
`;
